export default "__VITE_ASSET__yzm1Vlv7__"